import { render, staticRenderFns } from "./CreateEditDepartment.vue?vue&type=template&id=29d191d4&scoped=true"
import script from "./CreateEditDepartment.vue?vue&type=script&lang=js"
export * from "./CreateEditDepartment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d191d4",
  null
  
)

export default component.exports